import { CardElement } from '@stripe/react-stripe-js';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
import { useBooleanState } from 'hooks/useBooleanState';
import { FullStoryExclude } from '../../../../shared/fullstory_privacy';
const cardElementStylesHasFocusCss = "c1x76vvs";
const cardElementStylesHasErrorCss = "csarwju";
const cardElementStylesCss = "cgjfy6y";
const CardElementStyles = forwardRef((props, ref) => {
  const {
    hasFocus,
    hasError,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardElementStylesCss, {
    [cardElementStylesHasFocusCss]: hasFocus,
    [cardElementStylesHasErrorCss]: hasError
  }, props.className)} />;
});
const CardField = ({
  onChange,
  onReady,
  onEscape,
  error,
  disabled,
  ...props
}) => {
  const [hasError, setHasError] = useState(false);
  const [hasFocus, focus, blur] = useBooleanState(false);
  const handleChange = changeObject => {
    setHasError(Boolean(changeObject.error));
    onChange(changeObject);
  };
  return <div {...props}>
      <FullStoryExclude>
        <CardElementStyles as={CardElement} options={{
        disabled
      }} hasError={hasError} hasFocus={hasFocus} onChange={handleChange} onFocus={focus} onBlur={blur} onReady={onReady} onEscape={onEscape} />
      </FullStoryExclude>
      <ErrorMessage message={error} />
    </div>;
};
export default CardField;

require("./card_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./card_field.js");